import React from 'react';
import { Box } from '@mui/material';
import { BackgroundErrorPanel } from '../BackgroundErrorPanel';
import bgImage from '@/assets/images/background.jpg';
import { BackgroundErrorHeader } from '../BackgroundErrorHeader';

export const SiteMaintenanceComponent = () => {
  return (
    <Box>
      <BackgroundErrorHeader />
      <BackgroundErrorPanel
        title="Site Maintenance"
        isTitleUnderlined={true}
        message={
          <>
            Our site is currently undergoing scheduled maintenance and upgrades,
            but we will return shortly.
            <br />
            <br />
            We sincerely apologize for the inconvenience.
            <br />
            <br />
            Thank you for your patience.
          </>
        }
        imageSrc={bgImage}
        altText="Site Maintenance"
        backgroundBoxStyles={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          height: { xs: '50%', sm: '70%', md: '70%' },
        }}
        contentBoxStyles={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          padding: { xs: '20px', sm: '30px', md: '50px' },
          textAlign: 'center',
          maxWidth: { xs: '80%', sm: '60%', md: '30%' },
          maxHeight: 'auto',
          overflow: 'hidden',
        }}
      />
    </Box>
  );
};
